export const getError = (error) => {
  return error.response && error.response.data.message
    ? error.response.data.message
    : error.message;
};

const OTP_PROVIDER_LABELS = {
  // The built-in worker: this project's own WhatsApp client, no outside
  // gateway and no browser involved.
  baileys: 'WhatsApp',
  openwa: 'WhatsApp (OWA)',
  waha: 'WhatsApp (WAHA)',
  // BeSends SMS. The stored key stays 'pitech' so older history rows match.
  pitech: 'SMS',
  // WhatsApp through the same BeSends account.
  besendswa: 'WhatsApp',
  // Retired gateways. Kept so old history rows still read as something.
  greenweb: 'SMS (GW)',
  androidsms: 'SMS (phone)',
};

export const otpProviderLabel = (provider) => (
  OTP_PROVIDER_LABELS[String(provider || '').toLowerCase()] || provider || 'Unknown'
);

// Admin screens name the gateway too; members only need to know SMS/WhatsApp.
const OTP_GATEWAY_LABELS = { pitech: 'BeSends SMS', besendswa: 'BeSends WhatsApp' };
export const otpGatewayLabel = (provider) => (
  OTP_GATEWAY_LABELS[String(provider || '').toLowerCase()] || otpProviderLabel(provider)
);

// A URL-safe identifier for the /product/:slug route. Older products have raw,
// un-normalized slugs (spaces, uppercase, '#', even whole image URLs) that break
// the HashRouter — the '#' truncates the hash, and '/' or ':' shatter the path.
// Use the slug only when it is already clean; otherwise fall back to the _id,
// which the backend /slug/:slug endpoint also resolves.
const isCleanSlug = (slug) => typeof slug === 'string' && /^[a-z0-9-]+$/.test(slug);

export const productPath = (product) => {
  if (!product) return '/product/';
  const key = isCleanSlug(product.slug) ? product.slug : (product._id || product.slug || '');
  return `/product/${key}`;
};
